import { styled } from '@uhg-abyss/web/tools/styled';
import { Link } from '@uhg-abyss/web/ui/Link';

export const ReferralBannerBoxBanner = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  lineHeight: '20px',
  padding: '12px 16px',
  width: 'fit-content',
  columnGap: '16px',
  alignSelf: 'stretch',
  borderRadius: '4px',
  backgroundColor: '$core.color.brand.5',
  '.abyss-popover-trigger ~ div': {
    zIndex: '9 !important',
  },

  '@media (max-width: 464px)': {
    width: '100%',
  },
});

export const ReferralBanner = styled('div', {
  display: 'flex',
  lineHeight: '20px',
});

export const ReferralRequiredIcon = styled('div', {
  width: '24px',
  height: '24px',
  marginRight: '8px',
});

export const ContactMyPCP = styled('div', {
  whiteSpace: 'nowrap',
});
export const ArrowIcon = styled('div', {
  width: '24px',
  height: '24px',
  marginLeft: '4px',
  '@media (max-width: 464px)': {
    width: '18px',
    height: '18px',
  },
});
export const ReferralBannerReferralRequired = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  fontWeight: '$medium',
  fontSize: '16px',
  lineHeight: '20px',
  color: '$core.color.brand.100',
  columnGap: '16px',
  alignItems: 'center',
  '@media (max-width: 464px)': {
    fontSize: '14.22px',
    paddingLeft: '0',
    lineHeight: '17px',
    marginRight: '0px',
  },
});

export const PopOverStyle = {
  'abyss-popover-trigger-icon': {
    width: '16px',
    height: '16px',
    marginLeft: '4px',
  },
};
export const ReferralBannerTextContainer = styled('div', {
  fontWeight: '600',
  fontSize: '16px',
  lineHeight: '20px',
  color: '$core.color.brand.100',
  '@media (max-width: 464px)': {
    fontSize: '14.22px',
  },
  '&>div': {
    display: 'inline-block',
    verticalAlign: 'middle',
    height: '16px',
  },
  '&>button': {
    verticalAlign: 'middle',
    marginBottom: '2px',
  },
});
export const ReferralBannerSpecialtyContainer = styled('div', {
  fontWeight: '$medium',
  fontSize: '16px',
  lineHeight: '20px',
  color: '#4B4D4F',
  marginRight: '16px',
  marginTop: '2px',
  'li:first-of-type': {
    listStyle: 'none',
    marginLeft: '0 !important',
  },
  'li:last-of-type': {
    marginRight: '0 !important',
  },
  '@media (max-width: 464px)': {
    fontSize: '14.22px',
    lineHeight: '20px',
    marginTop: '4px',
  },
});

export const ReferralBannerContactPCP = styled('button', {
  marginLeft: '16px',
  cursor: 'pointer',
  display: 'flex',
  color: '$core.color.brand.60',
  fontWeight: 'bold',
  fontSize: '$md',
  lineHeight: '20px',
  flexWrap: 'nowrap',
  justifyContent: 'center',
  alignItems: 'center',
  '@media (max-width: 464px)': {
    fontSize: '12.64px',
    lineHeight: '16px',
  },
  '@media (max-width: 744px)': {
    marginLeft: '0px',
  },
});

export const ReferralBannerNeedHelp = styled(Link, {
  '&.abyss-link-root': {
    height: '26px',
    width: '177px',
    color: '$core.color.brand.60',
    fontSize: '12.64px',
    display: 'flex',
    padding: '5px 8px 5px 10px',
    background: '#FFFFFF',
    borderRadius: '4px',
    alignItems: 'center',
    fontWeight: 'bold',
    marginLeft: '16px',
    '@media (max-width: 464px)': {
      margin: '0px 8px 0px 8px',
      lineHeight: '16px',
    },
  },
  '.abyss-popover-trigger ~ div': {
    zIndex: '9 !important',
  },
});
